import { getSecondsFromNow, getBestFitGranularity } from '../../datetimeUtils';

export const periods = [
  {
    label: 'Last 5 minutes',
    secondsFromNow: 5 * 60,
  },
  {
    label: 'Last 15 minutes',
    secondsFromNow: 15 * 60,
  },
  {
    label: 'Last hour',
    secondsFromNow: 60 * 60,
  },
  {
    label: 'Last 6 hours',
    secondsFromNow: 6 * 60 * 60,
  },
  {
    label: 'Last 24 hours',
    secondsFromNow: 24 * 60 * 60,
  },
  {
    label: 'Last 48 hours',
    secondsFromNow: 48 * 60 * 60,
  },
  {
    label: 'Last 7 days',
    secondsFromNow: 7 * 24 * 60 * 60,
  },
  {
    label: 'Last 14 days',
    secondsFromNow: 14 * 24 * 60 * 60,
  },
  {
    label: 'Last 30 days',
    secondsFromNow: 30 * 24 * 60 * 60,
  },
  {
    label: 'Last 100 days',
    secondsFromNow: 100 * 24 * 60 * 60,
  },
];

export const pollingIntervals = [
  {
    label: 'Paused',
    value: 0,
  },
  {
    label: '5m',
    value: 60_000 * 5,
    default: true,
  },
];

export function getGranularityForDateRange(dateRange = {}) {
  let timeWindow = 0;
  const { startDate: start, endDate: end, label } = dateRange;

  if (label) {
    const period = periods.find((p) => p.label === label);
    timeWindow = period.secondsFromNow;
  } else if (start && end) {
    const diff = end - start;
    timeWindow = diff > 0 ? diff / 1000 : 86_400;
  }
  return getBestFitGranularity(timeWindow);
}

export const getRangeFromLabel = (label) => {
  const range = { label };
  const { secondsFromNow = 0 } = periods.find((x) => x.label === label) || {};
  range.startDate = getSecondsFromNow(-secondsFromNow);
  range.endDate = Date.now();
  return {
    ...range,
    granularity: getGranularityForDateRange(range),
    duration: range.endDate - range.startDate,
  };
};

export const getRangeFromPartial = (partial) => {
  const range = { ...partial };
  return {
    ...range,
    granularity: getGranularityForDateRange(range),
    duration: range.endDate - range.startDate,
    label: null,
  };
};
